<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const GoogleIcon = getIcon("GoogleIcon");
export let className = "";
</script>

{#if typeof GoogleIcon === 'string'}
	<img src={GoogleIcon} alt={$t(Verbiage.icon_alt, 'alts')} class={className} />
{:else if typeof GoogleIcon === 'function'}
	<svelte:component this={GoogleIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
